import * as session from './session';
import * as vehicleAd from './vehicleAd';
import * as vehicleMake from './vehicleMake';
import * as vehicleModel from './vehicleModel';
import * as vehicleGeneration from './vehicleGeneration';
import * as vehicleUtil from './vehicleUtil';
import * as vehicleFeature from './vehicleFeature';
import * as color from './color';
import * as vehicleBodyType from './vehicleBodyType';
import * as vehicleEngineType from './vehicleEngineType';
import * as user from './user';
import * as metaData from './metaData';
import * as bank from './bank';
import * as bankForm from './bankForm';
import * as bankUser from './bankUser';
import * as activeTabKey from './activeTab';
import * as city from './city';
import * as banner from './banner';
import * as packages from './package';
import * as service from './service';
import * as sliderImage from './sliderImage';
import * as counts from './counts';
import * as userStats from './userStats';
import * as vehicleStats from './vehicleStats';
import * as blogsStats from './blogsStats';
import * as suggestion from './suggestion';
import * as orders from './order';
import * as vehicleUploads from './vehicleUploads';
import * as leads from './leads';
import * as inspectionOrders from './inspectionOrders';
import * as calender from './calender';
import * as tags from './tags';
import * as userLevels from './userLevels';
import * as signupStats from './signupStats';

export const Actions = {
	...session,
	...vehicleMake,
	...vehicleModel,
	...vehicleGeneration,
	...user,
	...vehicleAd,
	...metaData,
	...vehicleUtil,
	...vehicleFeature,
	...color,
	...vehicleBodyType,
	...vehicleEngineType,
	...bankForm,
	...bankUser,
	...activeTabKey,
	...city,
	...bank,
	...sliderImage,
	...banner,
	...packages,
	...service,
	...counts,
	...userStats,
	...vehicleStats,
	...blogsStats,
	...suggestion,
	...vehicleUploads,
	...orders,
	...leads,
	...inspectionOrders,
	...calender,
	...tags,
	...userLevels,
	...signupStats,
};
